import React from 'react';
import PropTypes from 'prop-types';

import { validate } from 'Data/stories/StoryValidators.js';

import Form from "Components/Form";
import ProjectListSelect from "Components/ProjectListSelect";

import Modal from "UI/Modal";
import Button from 'UI/Button';
import TextField from "UI/Form/TextField";

export default class StorySettingsDialog extends React.Component
{
    state = {
        projects: this.props.story.projects,

        busy: false,
    };

    static propTypes = {
        story: PropTypes.object.isRequired,
        projects: PropTypes.array,

        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,

        onSubmit: PropTypes.func.isRequired,
    };

    static defaultProps = {
        projects: []
    };

    onSubmit = (data) => {
        this.setState({busy: true}, () => {
            const payload = {
                ...data,
                projects: this.state.projects
            };

            this.props.onSubmit(payload)
                .then(this.props.onClose)
                .catch(
                    () => this.setState({busy: false})
                );
        });
    };

    onClose = e => {
        e.preventDefault();
        this.props.onClose();
    };

    handleChangeProject = (id, on) => {
        if (on) {
            return this.setState({projects: [...this.state.projects, id]});
        }

        this.setState({projects: this.state.projects.filter(
            project => project !== id
        )});
    };

    render()
    {
        const defaults = {
            name: this.props.story.name,
            description: this.props.story.description,
        };

        return <Modal open={this.props.open} onClose={this.props.onClose} className='max-w-xs w-full'>
            <Modal.Header>
                Story Settings
            </Modal.Header>
            <Modal.Content>
                <Form id='story-settings' defaults={defaults} validate={validate} onSubmit={this.onSubmit}>
                    {(data, onChange, validation) => (
                        <>
                            <fieldset disabled={this.state.busy} className='space-y-6'>
                                <div className='flex-1'>
                                    <TextField
                                        id='name'
                                        name='name'
                                        label='Story name:'
                                        value={data.name}
                                        onChange={onChange('name')}
                                        error={validation.hasErrors('name')}
                                        help={validation.getErrors('name')}
                                    />
                                </div>

                                <div className='flex-1'>
                                    <TextField
                                        id='description'
                                        name='description'
                                        label='Story description:'
                                        value={data.description}
                                        onChange={onChange('description')}
                                        error={validation.hasErrors('description')}
                                        help={validation.getErrors('description')}
                                    />
                                </div>

                                {
                                    this.props.projects.length > 0 && <div className='flex-1'>
                                        <div className='flex justify-between text-gray-700'>
                                            <label className="block text-sm font-medium leading-5">Projects</label>
                                        </div>

                                        <ProjectListSelect
                                            projects={this.props.projects}
                                            selected={this.state.projects}
                                            onChange={this.handleChangeProject}
                                        />
                                    </div>
                                }
                            </fieldset>
                        </>
                    )}
                </Form>
            </Modal.Content>
            <Modal.Footer>
                <Button form='story-settings' type='primary' busy={this.state.busy}>Update</Button>
                <Button onClick={this.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>;
    }
}